module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "walnut-cove-abstract-hayman-0.5839c318.jpg";